import { render, staticRenderFns } from "./vUSContainsPercentOfForm.vue?vue&type=template&id=b2503a9e"
import script from "./vUSContainsPercentOfForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./vUSContainsPercentOfForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports